import styled from 'styled-components';

export const Container = styled.div`
  padding-left: 250px;
`;

export const ContentContainer = styled.main`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;

export const SubmitButton = styled.button`
  background-color: #000;
  color: #f2f2f2;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ReOpenLinkModalButton = styled.button`
  background-color: transparent;
  border: 1px solid #000;
  color: #000;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
`;